import highlightIcon from '@disy/cadenza-icons/crosshairs.svg';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Icon from 'ol/style/Icon';

export const MIN_GAP_SIZE_IN_MILLISECONDS = 1000;
export const GAP_SIZE_FACTOR = 10;
export const MINIMAL_FADING_FACTOR = 0.2;

export const ARROW_LENGTH = 16; // Pixel
export const ARROW_WIDTH = 12; // Pixel
export const ARROW_MINIMUM_LINE_LENGTH_MULTIPLIER = 1.5; // Pixel
export const ARROW_MINIMUM_VISIBILITY_DISTANCE = ARROW_LENGTH * ARROW_MINIMUM_LINE_LENGTH_MULTIPLIER; // Pixel
export const ARROW_MINIMUM_VISIBILITY_DISTANCE_SQUARED = ARROW_MINIMUM_VISIBILITY_DISTANCE * ARROW_MINIMUM_VISIBILITY_DISTANCE; // Pixel²
let arrowImage;

export function createArrowStyle () {
  if (!arrowImage) {
    arrowImage = createArrowImage(ARROW_LENGTH, ARROW_WIDTH, 'black');
  }
  return new Style({
    image: new Icon({
      img: arrowImage,
      imgSize: [ arrowImage.width, arrowImage.height ]
    })
  });
}

export const LINE_TO_PREDECESSOR_STYLE = new Style({
  stroke: new Stroke({ color: 'black', width: 2 })
});
export const LINE_TO_SIBLING_STYLE = LINE_TO_PREDECESSOR_STYLE;

export const HIGHLIGHT_ICON_SRC = `data:image/svg+xml;base64,${btoa(highlightIcon)}`; // base64 is required for IE
export const HIGHLIGHT_STYLE = new Style({
  image: new Icon(({
    src: HIGHLIGHT_ICON_SRC,
    imgSize: [ 26, 26 ] // required for IE, see https://openlayers.org/en/latest/apidoc/module-ol_style_Icon.html
  })),
  zIndex: 100
});

function createArrowImage (length, width, color) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = length;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = color;

  const tip = { x: width / 2, y: 0 };
  const endLeft = { x: 0, y: length };
  const endRight = { x: width, y: length };

  ctx.beginPath();
  ctx.moveTo(tip.x, tip.y);
  ctx.lineTo(endLeft.x, endLeft.y);
  ctx.lineTo(endRight.x, endRight.y);
  ctx.lineTo(tip.x, tip.y);
  ctx.fill();
  return canvas;
}
